/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Close } from '@carbon/react/icons';
import { useTranslation } from '../../../Utilities/i18n/i18n.js';
import Skeleton from './skeleton.js';

var Banner = function Banner(_ref) {
  var color = _ref.color,
    withGradient = _ref.withGradient,
    dismissible = _ref.dismissible,
    closeButtonLabel = _ref.closeButtonLabel,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dismissed = _useState2[0],
    setDismissed = _useState2[1];
  if (withGradient) {
    console.warn('Banner prop `withGradient` will be removed in the upcoming v4 release. Use `color: gradient` prop instead.');
  }
  var closeButtonLabelText = closeButtonLabel || t('Close');
  return !dismissed && /*#__PURE__*/React.createElement("div", {
    className: classnames('cpc--banner', {
      'cpc--banner--gradient': color === 'gradient' || withGradient,
      'cpc--banner--blue': color === 'blue'
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--banner__children-container"
  }, children), dismissible && /*#__PURE__*/React.createElement("button", {
    className: "cpc--banner__close-button",
    type: "button",
    title: closeButtonLabelText,
    "aria-label": closeButtonLabelText,
    onClick: function onClick() {
      return setDismissed(true);
    }
  }, /*#__PURE__*/React.createElement(Close, null)));
};
Banner.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['blue', 'gradient', 'none']),
  withGradient: PropTypes.bool,
  dismissible: PropTypes.bool,
  closeButtonLabel: PropTypes.string
};
Banner.skeleton = Skeleton;
var Banner$1 = Banner;

export { Banner$1 as default };
